export default `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.45 10.67L15.522 4.34697V8.97697L9.63499 13.615L15.522 13.619V16.994L21.45 10.67ZM0.549988 10.669L6.47899 16.992V12.398L12.365 7.72397L6.47999 7.71997V4.34497L0.549988 10.669Z" fill="black"/>
</svg>`;
